import { InfoTooltip } from "react-migration/components/InfoTooltip";

interface SectionWithHeaderTooltipProps {
  title: string;
  tooltipText: string;
  children: React.ReactNode;
}

export function SectionWithHeaderTooltip({ title, tooltipText, children }: SectionWithHeaderTooltipProps) {
  return (
    <section className="flex flex-col gap-2">
      <div className="flex gap-x-2">
        <h1 className="text-sm text-text-base-primary font-medium leading-5">{title}</h1>
        <InfoTooltip>{tooltipText}</InfoTooltip>
      </div>
      {children}
    </section>
  );
}
